document.addEventListener('DOMContentLoaded', () => {  
  const mentionedSlider = document.querySelector('.mentionedWrapper__slider');
  
  if (mentionedSlider) {
      const splide = new Splide(mentionedSlider, {
          arrows: false,
          type: 'loop',
          pagination: true,
          gap: '32px',
          perMove: 1,
          focus: 'center',
          autoWidth: true,
      });
  
      splide.mount();
  }
});